import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    /**
     * Storage  of storage service
     */
    private storage = localStorage;
    /**
     * Creates an instance of storage service.
     */
    constructor() {}
    /**
     * Sets storage service
     * @template T string
     * @param name string
     * @param params T
     */
    set<T>(name: string, params: T): void {
        this.storage.setItem(name, JSON.stringify(params));
    }
    /**
     * Sets item
     * @template T
     * @param key string
     * @param value T
     * @returns Observable<T>
     */
    setItem<T>(key: string, value: T): Observable<T> {
        this.storage.setItem(key, JSON.stringify(value));
        return of<T>(value);
    }
    /**
     * Gets storage service
     * @template T Interface
     * @param name string
     * @returns T
     */
    get<T>(name: string): T | null {
        const value = this.storage.getItem(name);
        return value ? JSON.parse(value) : null;
    }
    /**
     * Gets item
     * @template T
     * @param key string
     * @returns Observable<T>
     */
    getItem<T>(key: string): Observable<T> {
        const value = this.storage.getItem(key);
        return of<T>(
            value ? JSON.parse(this.storage.getItem(key)) : (null as T)
        );
    }
    /**
     * Remove item storage service
     */
    remove(name: string): void {
        this.storage.removeItem(name);
    }
    /**
     * Removes item
     * @param key string
     * @returns Observable<void>
     */
    removeItem(key: string): Observable<void> {
        return of(this.storage.removeItem(key));
    }
    /**
     * Clears storage service
     */
    clear(): void {
        this.storage.clear();
    }
}
